import type { ServiceStoreConfig } from "../types/ServiceStoreTypes";
import { dashboardServiceStores } from "@intrasync/dashboard";

/**
 * Developer Dashboard ServiceStores — the four @intrasync/dashboard needs for
 * its default (`dashboard`) mount: `dashboard-boards`, `dashboard-widget-instances`,
 * `dashboard-shares`, `dashboard-user-prefs`. (`dashboard-data` has no store:
 * it is a custom-method endpoint reached through the library's client.)
 *
 * The configs come FROM THE LIBRARY, not from a hand copy: the store `name`
 * IS the Feathers path the host-mounted @intrasync/dashboard-api registers,
 * and the library's `hostBinding` looks the stores up on the rootStore by the
 * derived keys (`dashboardBoardsStore`, …). Re-typing them here would be a
 * second place for the paths to drift.
 *
 * The options are the library's doctrine and are pinned by dashboard.stores.test.ts:
 *  - `enableStorage: false` — a board is tenant + user scoped; a private board
 *    must never sit in another person's browser cache;
 *  - `enableOffline: false` — a write that cannot reach the server must FAIL
 *    VISIBLY (the view store's `syncError`), never be queued silently;
 *  - `disableInitialFind` on instances/shares — fetched per board, so a mount
 *    never pulls every instance of every readable board at boot;
 *  - `exhaustivePagination` on boards/instances — one board is one page.
 *
 * THE CAST: HQ's `ServiceStoreOptions` (types/ServiceStoreTypes.ts) does not
 * declare `exhaustivePagination`, and its `serviceView` is a rich app type the
 * library's loose carrier is not assignable to — so the library's
 * `ServiceStoreConfig[]` cannot be typed as HQ's without a cast either way.
 * This is the ONE boundary where it happens (precedent: rootStoreConfig.ts
 * `serviceStores as unknown as RootStoreProps["serviceStores"]`); the runtime
 * options reach the library unchanged, which the test asserts field by field.
 */
export const dashboardStores: ServiceStoreConfig[] =
  dashboardServiceStores as unknown as ServiceStoreConfig[];
